/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const listBodiesMessages = defineMessages({
    titleOne: {
        id: 'shared.listBodies.titleOne',
        defaultMessage: 'Create a schema that matches your real-world scenario.'
    },
    titleTwo: {
        id: 'shared.listBodies.titleTwo',
        defaultMessage: 'Use a similar number of examples for each intent.'
    },
    titleThree: {
        id: 'shared.listBodies.titleThree',
        defaultMessage: 'Use examples with distinct vocabulary.'
    },
    titleFour: {
        id: 'shared.listBodies.titleFour',
        defaultMessage: 'Apply active learning to add user utterances.'
    },
    titleFive: {
        id: 'shared.listBodies.titleFive',
        defaultMessage: 'Add phrase lists and patterns.'
    },
    bodyTextOneA: {
        id: 'shared.listBodies.bodyTextOneA',
        defaultMessage: 'Create an'
    },
    intent: {
        id: 'shared.listBodies.intent',
        defaultMessage: 'intent'
    },
    bodyTextOneB: {
        id: 'shared.listBodies.bodyTextOneB',
        defaultMessage: 'for each action your bot can perform. Use'
    },
    entities: {
        id: 'shared.listBodies.entities',
        defaultMessage: 'entities'
    },
    bodyTextOneC: {
        id: 'shared.listBodies.bodyTextOneC',
        defaultMessage: 'to collect data needed to complete that action.'
    },
    bodyTextTwoA: {
        id: 'shared.listBodies.bodyTextTwoA',
        defaultMessage: `When LUIS makes a prediction, it gets results from all models and picks the top scoring model.
        Example utterances assigned to one intent act as negative examples for all other intents.`
    },
    bodyTextTwoB: {
        id: 'shared.listBodies.bodyTextTwoB',
        defaultMessage: 'Intents with significantly more positive examples are more likely to receive positive predictions. This is called'
    },
    dataImbalance: {
        id: 'shared.listBodies.dataImbalance',
        defaultMessage: 'data imbalance.'
    },
    bodyTextThreeA: {
        id: 'shared.listBodies.bodyTextThreeA',
        defaultMessage: `Make sure the vocabulary for each intent is used only in that intent.
        Intents with overlapping vocabulary can confuse LUIS and cause the scores for the top intents to be very close.`
    },
    bodyTextThreeB: {
        id: 'shared.listBodies.bodyTextThreeB',
        defaultMessage: 'This causes'
    },
    unclearPredictions: {
        id: 'shared.listBodies.unclearPredictions',
        defaultMessage: 'unclear predictions.'
    },
    bodyTextFourA: {
        id: 'shared.listBodies.bodyTextFourA',
        defaultMessage: 'Use'
    },
    activeLearning: {
        id: 'shared.listBodies.activeLearning',
        defaultMessage: 'active learning'
    },
    bodyTextFourB: {
        id: 'shared.listBodies.bodyTextFourB',
        defaultMessage:
            'to add real-world user utterances to your model. Real user utterances can reveal patterns of word choice and placement.'
    },
    bodyTextFourC: {
        id: 'shared.listBodies.bodyTextFourC',
        defaultMessage:
            'LUIS is meant to learn quickly with few examples. User utterances will help you find examples with a variety of formats.'
    },
    phraseLists: {
        id: 'shared.listBodies.phraseLists',
        defaultMessage: 'Phrase lists'
    },
    bodyTextFiveA: {
        id: 'shared.listBodies.bodyTextFiveA',
        defaultMessage: 'designate words or phrases as more significant to your app than other words.'
    },
    patterns: {
        id: 'shared.listBodies.patterns',
        defaultMessage: 'Patterns'
    },
    bodyTextFiveB: {
        id: 'shared.listBodies.bodyTextFiveB',
        defaultMessage: 'can improve your prediction accuracy when word order is important to differentiate between intents.'
    },
    bodyTextFiveC: {
        id: 'shared.listBodies.bodyTextFiveC',
        defaultMessage: `Phrase lists and patterns are weighted more heavily than examples,
        so they should be added after adding user utterances to your example data.`
    }
});
